<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button
          icon="el-icon-plus"
          type="primary"
          @click="handleEdit(edit, null)"
        >
          设置房量
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="" class="pr-10">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="分店"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="pr-10">
            <el-select
              v-model="queryForm.roomTypeId"
              clearable
              placeholder="选择房型"
            >
              <el-option
                v-for="item in roomTypeList"
                :key="item.roomTypeId"
                :label="item.title"
                :value="item.roomTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="酒店"
        prop="hotel.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="日期"
        prop="date"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="房量"
        prop="volume"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            class="mr-10"
            @click="handleEdit(singleEdit, row)"
          >
            编辑
          </el-button>
          <!-- <el-button type="text" @click="handleDelete(row)">删除</el-button> -->
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <single-edit ref="singleEdit" @fetch-data="fetchData"></single-edit>
  </div>
</template>

<script>
import moment from 'moment'
import { findVolumeAll, findRoomTypeList, findVolumeList } from '@/api/room'
import { getAllBranchs } from '@/api/branch'
import Edit from './edit.vue'
import SingleEdit from './single-edit.vue'
import { reactive, ref, getCurrentInstance } from 'vue'
// import commomFunction from '../roomPrice/common'

export default {
  name: 'RoomCountIndex',
  components: { Edit, SingleEdit },
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const roomTypeList = reactive([])
    const branchList = reactive([])
    const queryForm = reactive({
      branchId: '',
      roomTypeId: '',
      date: null,
      page: 1,
      size: 10,
    })
    const edit = ref(null)
    const singleEdit = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      const data = Object.assign({}, queryForm)
      if (data.date) {
        data.startDate = data.date[0]
        data.endDate = data.date[1]
      }
      delete data.date
      const { list: list1, total: total1 } = await findVolumeList(data)
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = async () => {
      fetchData()
    }
    //添加和编辑
    const handleEdit = (edit, row) => {
      edit.showEdit(row)
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const getAllRoomType = async () => {
      const { list } = await findRoomTypeList({ page: 1, size: 1000 })
      roomTypeList.length = 0
      roomTypeList.push(...list)
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    //拉取数据
    getAllBranchList()
    getAllRoomType()
    queryData()
    return {
      list,
      listLoading,
      layout,
      total,
      queryForm,
      moment,
      edit,
      singleEdit,
      roomTypeList,
      branchList,
      fetchData,
      queryData,
      handleEdit,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
